export default __webpack_public_path__ + "static/media/mx-flag.f174eff3.svg";